import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

/**
 * @see {@link https://jira.vk.team/browse/CLOUDWEB-20464} Фейкдор оффлайн-режима в редакторе
 */
const offlineMode = getFeature('ab-offline-mode-fakedoor') as string | undefined;

export const offlineModeEnabled = offlineMode === 'a';

registerExperiment('offline-mode', offlineMode, [AnalyticEventNames.OFFLINE_MODE_CLICK]);
